<template>
    <div class="ReviewCardDemo">
        <h5>Basic Card</h5>
        <div class="ReviewCardDemo__row">
            <RPReviewCard
                :review="postedResponse"
                :location="locationParsed"
                :profile="profilesParsed"
                :suggested-responses="suggestedResponses.attributes.responses"
                :can-create="userPermissions.create"
                :can-approve="userPermissions.approve"
                :can-post="userPermissions.post"
            />
        </div>
        <h5>Compact Card</h5>
        <div class="ReviewCardDemo__row">
            <RPReviewCard
                :review="postedResponse"
                :location="locationParsed"
                :profile="profilesParsed"
                compact
            />
        </div>
        <div class="ReviewCardDemo__row">
            <RPCompactReviewCard
                :style="{width: '25%'}"
                :review="postedResponse"
                :location="locationParsed"
                :profile="profilesParsed"
            />
        </div>
        <h5>Notes Card</h5>
        <div class="ReviewCardDemo__row">
            <RPNotesCard
                :notes="postedResponse.response.timeline"
                :review-id="123"
                :is-card="true"
            />
        </div>
        <h5>Loading Card</h5>
        <div class="ReviewCardDemo__row">
            <RPReviewCard
                :review="postedResponse"
                :location="locationParsed"
                :profile="profilesParsed"
                status="loading"
            />
        </div>
        <h5>Loading Card (Compact)</h5>
        <div class="ReviewCardDemo__row">
            <RPReviewCard
                :review="postedResponse"
                :location="locationParsed"
                :profile="profilesParsed"
                status="loading"
                compact
            />
            <RPReviewCard
                :review="postedResponse"
                :location="locationParsed"
                :profile="profilesParsed"
                status="loading"
                compact
            />
        </div>
        <h5>Unpublished Response</h5>
        <div class="ReviewCardDemo__row">
            <RPReviewCard
                :review="reviewNoResponse"
                :location="locationParsed"
                :profile="profilesParsed"
                :suggested-responses="suggestedResponses.attributes.responses"
                :can-create="userPermissions.create"
                :can-approve="userPermissions.approve"
                :can-post="userPermissions.post"
            />
        </div>
        <h5>Pending Response</h5>
        <div class="ReviewCardDemo__row">
            <RPReviewCard
                :review="reviewPending"
                :location="locationParsed"
                :profile="profilesParsed"
                :suggested-responses="suggestedResponses.attributes.responses"
                :can-create="userPermissions.create"
                :can-approve="userPermissions.approve"
                :can-post="userPermissions.post"
            />
        </div>
        <h5>Approved Response</h5>
        <div class="ReviewCardDemo__row">
            <RPReviewCard
                :review="reviewApproved"
                :location="locationParsed"
                :profile="profilesParsed"
                :suggested-responses="suggestedResponses.attributes.responses"
                :can-create="userPermissions.create"
                :can-approve="userPermissions.approve"
                :can-post="userPermissions.post"
            />
        </div>
        <h5>On Hold Response</h5>
        <div class="ReviewCardDemo__row">
            <RPReviewCard
                :review="reviewOnHold"
                :location="locationParsed"
                :profile="profilesParsed"
                :suggested-responses="suggestedResponses.attributes.responses"
                :can-create="userPermissions.create"
                :can-approve="userPermissions.approve"
                :can-post="userPermissions.post"
            />
        </div>
        <h5>Rejected Response</h5>
        <div class="ReviewCardDemo__row">
            <RPReviewCard
                :review="reviewRejected"
                :location="locationParsed"
                :profile="profilesParsed"
                :suggested-responses="suggestedResponses.attributes.responses"
                :can-create="userPermissions.create"
                :can-approve="userPermissions.approve"
                :can-post="userPermissions.post"
            />
        </div>
        <h5>Closed Response</h5>
        <div class="ReviewCardDemo__row">
            <RPReviewCard
                :review="reviewClosed"
                :location="locationParsed"
                :profile="profilesParsed"
                :suggested-responses="suggestedResponses.attributes.responses"
                :can-create="userPermissions.create"
                :can-approve="userPermissions.approve"
                :can-post="userPermissions.post"
            />
        </div>
    </div>
</template>
<script>
import RPReviewCard from 'components/Common/ReviewCard/RPReviewCard.vue';
import RPCompactReviewCard from 'components/Common/ReviewCard/RPCompactReviewCard.vue';
import RPNotesCard from 'components/Common/ReviewCard/RPNotesCard.vue';
export default {
    name: 'ReviewCardDemo',
    components: {
        RPReviewCard,
        RPNotesCard,
        RPCompactReviewCard
    },
    data(){
        return {
            userPermissions: {
                approve: true,
                create: true,
                post: true,
            },
            suggestedResponses:
                {
                    "type": "suggested_responses",
                    "id": "2610",
                    "attributes": {
                        "responses": [
                            "Hello, thanks for the positive feedback! We're always happy to hear good things from our customers.",
                            "We are glad you enjoyed your experience at Stehr-Tromp. Please visit us again soon!",
                            "Thanks for the great review. It was a pleasure serving you as a customer.",
                            "This is great news! We're so happy to know that you had a good experience."
                        ]
                    }
                },
            reviewNoResponse: {
                "type": "reviews",
                "id": "1729",
                "review": "Vero vel minima dolor omnis voluptatem. Aliquid necessitatibus omnis nihil molestias hic. Et sit nobis non pariatur.",
                "rating": 2,
                "reviewer": "",
                "review_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "respond_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "share_url": "https://local.reviewpush.com/r/v/1729",
                "more_info_url": "https://local.reviewpush.com/i/1729",
                "review_date": "2020-05-04",
                "review_time": "18:54:59",
                "user_profile_image": "https://local.reviewpush.com/img/default-user-image.png",
                "metadata": null,
                "images": [],
                "publishable": true,
                "published": true,
                "attributed_review_id": null,
                "response": false,
                "response_can_be_posted_directly": true,
                "sentiment": ""

            },
            reviewPending: {
                "type": "reviews",
                "id": "1729",
                "review": "Vero vel minima dolor omnis voluptatem. Aliquid necessitatibus omnis nihil molestias hic. Et sit nobis non pariatur.",
                "rating": 2,
                "reviewer": "",
                "review_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "respond_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "share_url": "https://local.reviewpush.com/r/v/1729",
                "more_info_url": "https://local.reviewpush.com/i/1729",
                "review_date": "2020-05-04",
                "review_time": "18:54:59",
                "user_profile_image": "https://local.reviewpush.com/img/default-user-image.png",
                "metadata": null,
                "images": [],
                "publishable": true,
                "published": true,
                "attributed_review_id": null,
                "response": {
                    "type": "review_responses",
                    "id": 31,
                    "status": "Pending",
                    "response": "Iusto cupiditate temporibus vel qui quam vero. Quasi aliquam dolore fuga. Et sit non fugiat doloribus officia officia occaecati.",
                    "source_id": "",
                    "timeline": [
                        {
                            "type": "note",
                            "note": "Quo culpa au173543512344t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-05:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au2354235t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-06:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au4525724t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-07:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa23464326 aut numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-08:00"
                        },
                    ],
                    "available_actions": [],
                    "approved_at": "2020-04-29 12:10:57",
                    "posted_at": "2020-04-30 03:10:57",
                    "created_at": "2020-04-20 12:10:57",
                    "updated_at": "2020-04-28 12:10:57",
                    "creator": "Response Creator Approver",
                    "links": {
                        "self": "http://local.reviewpush.com/api/user/responses/31"

                    },
                    "user": "Response Creator Approver",
                    "response_date": "2020-04-30 03:10:57",
                },
                "response_can_be_posted_directly": true,
                "sentiment": ""

            },
            reviewApproved: {
                "type": "reviews",
                "id": "1729",
                "review": "Vero vel minima dolor omnis voluptatem. Aliquid necessitatibus omnis nihil molestias hic. Et sit nobis non pariatur.",
                "rating": 2,
                "reviewer": "",
                "review_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "respond_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "share_url": "https://local.reviewpush.com/r/v/1729",
                "more_info_url": "https://local.reviewpush.com/i/1729",
                "review_date": "2020-05-04",
                "review_time": "18:54:59",
                "user_profile_image": "https://local.reviewpush.com/img/default-user-image.png",
                "metadata": null,
                "images": [],
                "publishable": true,
                "published": true,
                "attributed_review_id": null,
                "response": {
                    "type": "review_responses",
                    "id": 31,
                    "status": "Approved",
                    "response": "Iusto cupiditate temporibus vel qui quam vero. Quasi aliquam dolore fuga. Et sit non fugiat doloribus officia officia occaecati.",
                    "source_id": "",
                    "timeline": [
                        {
                            "type": "note",
                            "note": "Quo culpa au173543512344t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-05:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au2354235t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-06:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au4525724t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-07:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa23464326 aut numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-08:00"
                        },
                    ],
                    "available_actions": [],
                    "approved_at": "2020-04-29 12:10:57",
                    "posted_at": "2020-04-30 03:10:57",
                    "created_at": "2020-04-20 12:10:57",
                    "updated_at": "2020-04-28 12:10:57",
                    "creator": "Response Creator Approver",
                    "links": {
                        "self": "http://local.reviewpush.com/api/user/responses/31"

                    },
                    "user": "Response Creator Approver",
                    "response_date": "2020-04-30 03:10:57",
                },
                "response_can_be_posted_directly": true,
                "sentiment": ""

            },
            reviewRejected: {
                "type": "reviews",
                "id": "1729",
                "review": "Vero vel minima dolor omnis voluptatem. Aliquid necessitatibus omnis nihil molestias hic. Et sit nobis non pariatur.",
                "rating": 2,
                "reviewer": "",
                "review_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "respond_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "share_url": "https://local.reviewpush.com/r/v/1729",
                "more_info_url": "https://local.reviewpush.com/i/1729",
                "review_date": "2020-05-04",
                "review_time": "18:54:59",
                "user_profile_image": "https://local.reviewpush.com/img/default-user-image.png",
                "metadata": null,
                "images": [],
                "publishable": true,
                "published": true,
                "attributed_review_id": null,
                "response": {
                    "type": "review_responses",
                    "id": 31,
                    "status": "Rejected",
                    "response": "Iusto cupiditate temporibus vel qui quam vero. Quasi aliquam dolore fuga. Et sit non fugiat doloribus officia officia occaecati.",
                    "source_id": "",
                    "timeline": [
                        {
                            "type": "note",
                            "note": "Quo culpa au173543512344t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-05:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au2354235t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-06:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au4525724t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-07:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa23464326 aut numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-08:00"
                        },
                    ],
                    "available_actions": [],
                    "approved_at": "2020-04-29 12:10:57",
                    "posted_at": "2020-04-30 03:10:57",
                    "created_at": "2020-04-20 12:10:57",
                    "updated_at": "2020-04-28 12:10:57",
                    "creator": "Response Creator Approver",
                    "links": {
                        "self": "http://local.reviewpush.com/api/user/responses/31"

                    },
                    "user": "Response Creator Approver",
                    "response_date": "2020-04-30 03:10:57",
                },
                "response_can_be_posted_directly": true,
                "sentiment": ""

            },
            reviewOnHold: {
                "type": "reviews",
                "id": "1729",
                "review": "Vero vel minima dolor omnis voluptatem. Aliquid necessitatibus omnis nihil molestias hic. Et sit nobis non pariatur.",
                "rating": 2,
                "reviewer": "",
                "review_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "respond_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "share_url": "https://local.reviewpush.com/r/v/1729",
                "more_info_url": "https://local.reviewpush.com/i/1729",
                "review_date": "2020-05-04",
                "review_time": "18:54:59",
                "user_profile_image": "https://local.reviewpush.com/img/default-user-image.png",
                "metadata": null,
                "images": [],
                "publishable": true,
                "published": true,
                "attributed_review_id": null,
                "response": {
                    "type": "review_responses",
                    "id": 31,
                    "status": "On Hold",
                    "response": "Iusto cupiditate temporibus vel qui quam vero. Quasi aliquam dolore fuga. Et sit non fugiat doloribus officia officia occaecati.",
                    "source_id": "",
                    "timeline": [
                        {
                            "type": "note",
                            "note": "Quo culpa au173543512344t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-05:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au2354235t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-06:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au4525724t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-07:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa23464326 aut numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-08:00"
                        },
                    ],
                    "available_actions": [],
                    "approved_at": "2020-04-29 12:10:57",
                    "posted_at": "2020-04-30 03:10:57",
                    "created_at": "2020-04-20 12:10:57",
                    "updated_at": "2020-04-28 12:10:57",
                    "creator": "Response Creator Approver",
                    "links": {
                        "self": "http://local.reviewpush.com/api/user/responses/31"

                    },
                    "user": "Response Creator Approver",
                    "response_date": "2020-04-30 03:10:57",
                },
                "response_can_be_posted_directly": true,
                "sentiment": ""

            },
            reviewClosed: {
                "type": "reviews",
                "id": "1729",
                "review": "Vero vel minima dolor omnis voluptatem. Aliquid necessitatibus omnis nihil molestias hic. Et sit nobis non pariatur.",
                "rating": 2,
                "reviewer": "",
                "review_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "respond_url": "http://hegmann.com/perferendis-et-eum-eos-aliquam.html",
                "share_url": "https://local.reviewpush.com/r/v/1729",
                "more_info_url": "https://local.reviewpush.com/i/1729",
                "review_date": "2020-05-04",
                "review_time": "18:54:59",
                "user_profile_image": "https://local.reviewpush.com/img/default-user-image.png",
                "metadata": null,
                "images": [],
                "publishable": true,
                "published": true,
                "attributed_review_id": null,
                "response": {
                    "type": "review_responses",
                    "id": 31,
                    "status": "Closed",
                    "response": "Iusto cupiditate temporibus vel qui quam vero. Quasi aliquam dolore fuga. Et sit non fugiat doloribus officia officia occaecati.",
                    "source_id": "",
                    "timeline": [
                        {
                            "type": "note",
                            "note": "Quo culpa au173543512344t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-05:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au2354235t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-06:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au4525724t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-07:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa23464326 aut numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-08:00"
                        },
                    ],
                    "available_actions": [],
                    "approved_at": "2020-04-29 12:10:57",
                    "posted_at": "2020-04-30 03:10:57",
                    "created_at": "2020-04-20 12:10:57",
                    "updated_at": "2020-04-28 12:10:57",
                    "creator": "Response Creator Approver",
                    "links": {
                        "self": "http://local.reviewpush.com/api/user/responses/31"

                    },
                    "user": "Response Creator Approver",
                    "response_date": "2020-04-30 03:10:57",
                },
                "response_can_be_posted_directly": true,
                "sentiment": ""

            },
            postedResponse: {
                "type": "reviews",
                "id": "2610",
                "review": "Dolor nulla modi illo possimus velit nostrum laborum. Sed deserunt ea nostrum rerum voluptatem alias. Voluptatibus pariatur debitis odit. Rerum sed corrupti ea ullam ducimus quia.",
                "rating": 4,
                "reviewer": "",
                "review_url": "review.com",
                "respond_url": "respond.com",
                "share_url": "https://local.reviewpush.com/r/v/2610",
                "more_info_url": "https://local.reviewpush.com/i/2610",
                "review_date": "2020-04-30",
                "review_time": "12:10:54",
                "user_profile_image": "https://local.reviewpush.com/img/default-user-image.png",
                "metadata": {
                    "rating_change": [
                        {
                            "emailed": 0,
                            "updated_on": "2020-04-30 12:10:54",
                            "previous_rating": null
                        }
                    ]
                },
                "attributed_review_id": 1,
                "images": [
                    "https://local.reviewpush.com/img/default-user-image.png",
                    "https://local.reviewpush.com/img/default-user-image.png",
                    "https://local.reviewpush.com/img/default-user-image.png",
                ],
                "publishable": false,
                "published": true,
                "response": {
                    "type": "review_responses",
                    "id": 31,
                    "status": "Posted",
                    "response": "Iusto cupiditate temporibus vel qui quam vero. Quasi aliquam dolore fuga. Et sit non fugiat doloribus officia officia occaecati.",
                    "source_id": "",
                    "timeline": [
                        {
                            "type": "note",
                            "note": "Quo culpa au173543512344t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-05:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au2354235t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-06:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa au4525724t numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-07:00"
                        },
                        {
                            "type": "note",
                            "note": "Quo culpa23464326 aut numquam iusto. Nihil dolor error eveniet nesciunt et. Consequatur temporibus neque enim inventore et qui veritatis totam.",
                            "user": "Response Creator",
                            "user_id": 4,
                            "date": "2020-04-30T12:10:57-08:00"
                        },
                    ],
                    "available_actions": [],
                    "approved_at": "2020-04-29 12:10:57",
                    "posted_at": "2020-04-30 03:10:57",
                    "created_at": "2020-04-20 12:10:57",
                    "updated_at": "2020-04-28 12:10:57",
                    "creator": "Response Creator Approver",
                    "links": {
                        "self": "http://local.reviewpush.com/api/user/responses/31"

                    },
                    "user": "Response Creator Approver",
                    "response_date": "2020-04-30 03:10:57",
                },
                "response_can_be_posted_directly": true,
                "sentiment": ""
            },
            location: {
                "type": "location",
                "id": "1",
                "attributes": {
                    "name": "Stehr-Tromp",
                    "unique_identifier": "0",
                    "display_name": "Stehr-Tromp - 0",
                    "address_1": "608 Huels Ferry Suite 705",
                    "address_2": "",
                    "city": "East Deloresmouth",
                    "state": "AZ",
                    "zip": "95359",
                    "phone": "1-768-705-6728",
                    "email": "raymundo28@dickinson.com",
                    "latitude": null,
                    "longitude": null,
                    "website": "",
                    "brand": "Sed",
                    "region": "Ea",
                    "brand_id": 3,
                    "region_id": 4,
                    "reviews_count": null,
                    "profiles_count": null,
                    "notification_emails": [],
                    "aggregate": {
                        "rating": 1.52,
                        "rating_weighted": 1.34,
                        "reviews": 767
                    },
                    "landing_pages": {
                        "Review Request": "http://local.reviewpush.com/review/c/1",
                        "Feedback": "http://local.reviewpush.com/feedback/c/1"
                    },
                    "created": "2020-04-30 12:10:44",
                    "review_request_templates": [
                        {
                            "name": "Basic Feedback Request",
                            "id": 7
                        },
                        {
                            "name": "Basic Review Request",
                            "id": 6
                        },
                        {
                            "name": "Site Selection",
                            "id": 506
                        },
                        {
                            "name": "Styled Feedback Request",
                            "id": 8
                        },
                        {
                            "name": "Styled Hybrid Request",
                            "id": 10
                        },
                        {
                            "name": "Styled Review Request",
                            "id": 9
                        }
                    ],
                    "contact_lists": [
                        {
                            "name": "Company Default",
                            "id": null
                        },
                        {
                            "name": "None",
                            "id": 0
                        },
                        {
                            "name": "Feedback Submissions",
                            "id": 228
                        },
                        {
                            "name": "Marketing",
                            "id": 227
                        }
                    ],
                    "settings": {
                        "review_flagging": false,
                        "review_alerts_rating_threshold": ">= 0",
                        "review_request_default_template": null,
                        "custom_reply_urls": [],
                        "custom_logo": ""
                    },
                    "landing_page_settings": {
                        "review_landing_page_text": "",
                        "feedback_compliment_header_text": "",
                        "feedback_suggestion_header_text": "",
                        "feedback_complaint_header_text": "",
                        "feedback_compliment_text": "",
                        "feedback_suggestion_text": "",
                        "feedback_complaint_text": "",
                        "show_feedback_review_links": null,
                        "landing_page_forward_after_feedback": null,
                        "landing_page_custom_forward_url": "",
                        "feedback_select_option_text": "",
                        "feedback_please_rate_your_experience_text": "",
                        "feedback_would_you_mind_posting_text": "",
                        "feedback_landing_placeholder_review": "",
                        "feedback_landing_placeholder_email": "",
                        "feedback_landing_placeholder_name": "",
                        "landing_page_locale": "",
                        "landing_page_recaptcha_required": null,
                        "landing_page_contact_list_id": null,
                        "landing_page_contact_list_threshold": null,
                        "landing_page_google_analytics_account": "",
                        "landing_page_facebook_pixel_account": "",
                        "review_request_sites": []
                    },
                    "embedded_reviews_settings": {
                        "embedded_default_reviewer_name": "",
                        "embedded_management_tag": true,
                        "embedded_responder_name": "",
                        "feedback_reviewer_name_display": "",
                        "feedback_publish_toggle": null,
                        "feedback_auto_publish_threshold": null,
                        "embedded_feed_show_add_review_button": null
                    },
                    "default_embedded_reviews_feed_settings": {
                        "embedded_reviews_feedback_only": null,
                        "embedded_feed_show_responses": null,
                        "embedded_feed_reviews_per_page": 5,
                        "embedded_feed_sites": []
                    }
                }
            },
            profile: {
                "type": "profiles",
                "id": "202",
                "attributes": {
                    "location_id": 1,
                    "name": "",
                    "url": "http://example.com/",
                    "site": {
                        "id": 27,
                        "name": "Facebook",
                        "logo": "https://local.reviewpush.com/img/logos/facebook.png",
                        "icon": "https://local.reviewpush.com/img/icons/sites/icon-facebook.png"
                    },
                    "aggregate": {
                        "rating": "1.00",
                        "reviews": 264
                    },
                    "third_party_login_id": null,
                    "third_party_login_email": null,
                    "third_party_login_name": null,
                    "created": "2020-04-30 12:10:49"
                }
            },
        };
    },
    computed: {
        locationParsed() {
            return {
                id: this.location.id,
                ...this.location.attributes
            };
        },
        profilesParsed() {
            return {
                id: this.profile.id,
                ...this.profile.attributes
            };
        },
    }
};
</script>
<style lang="scss">
    .ReviewCardDemo {
        height: 500%;
        width: 100%;
        background: #F6F8F9;
        padding: 50px;

        h5 {
            margin-bottom: 1rem;
        }

        &__row {
            display: flex;
            & > * {
                margin: 0 25px 25px 0;
            }
        }
    }
</style>
